import { Button } from 'react-bootstrap'
import Btn_arrow_animation from '../../../animations/btn_arrow_animation/Btn_arrow_animation'
import "./Yellow_arrow_btn.css"

function Yellow_arrow_btn({ btnText, onClick }) {
    return (
        <>
            <section className='Yellow_arrow_btn_holder'>

                <Button className="Yellow_arrow_btn" onClick={onClick}>{btnText}  <Btn_arrow_animation /></Button>

            </section>
        </>
    )
}

export default Yellow_arrow_btn